(function() {
    "use strict";

    taillightUx.directive('tuxBindHtmlCompile', ['$compile', function ($compile) {

        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                scope.$watch(function () {
                    return scope.$eval(attrs.tuxBindHtmlCompile);
                }, function (value) {
                    element.html(value);
                    $compile(element.contents())(scope);
                });
            }
        }
    }]);

    tuxNumericController.$inject = ["$scope", "$element", "$tuxConstant"];

    function tuxNumericController($scope, $element, $tuxConstant) {

        var ctrl = this;
        ctrl.onKeyPress = onKeyPress;
        ctrl.scope = $scope;

        function hasDecimalPoint() {
            return ($element[0].value.indexOf(".") != -1) ? true : false;
        }

        function onKeyPress(e) {

            if (e.keyCode == $tuxConstant.KEY_CODE.DECIMAL_POINT || e.keyCode == $tuxConstant.KEY_CODE.PERIOD) {

                if (hasDecimalPoint()) {
                    e.preventDefault();
                }

                return true;
            }

            var keyCode = e.keyCode;

            function isSpecialKey() {

                var keys = [
                    $tuxConstant.KEY_CODE.BACKSPACE,
                    $tuxConstant.KEY_CODE.TAB,
                    $tuxConstant.KEY_CODE.ENTER,
                    $tuxConstant.KEY_CODE.SHIFT,
                    $tuxConstant.KEY_CODE.CTRL,
                    $tuxConstant.KEY_CODE.ALT,
                    $tuxConstant.KEY_CODE.PAUSE,
                    $tuxConstant.KEY_CODE.CAPSLOCK,
                    $tuxConstant.KEY_CODE.ESCAPE,
                    $tuxConstant.KEY_CODE.LEFT_VENDOR_KEY,
                    $tuxConstant.KEY_CODE.RIGHT_VENDOR_KEY,
                    $tuxConstant.KEY_CODE.SELECT
                ];

                return (keyCode && keys.indexOf(keyCode) != -1) ? true : false;
            }

            if ((keyCode < 48 || (keyCode > 57 && keyCode < 96) || keyCode > 105) && !isSpecialKey() || e.shiftKey)
                e.preventDefault();

            return true;
        }
    };


    var tuxNumericPostLink = function(scope, element, attrs, controller) {

        element.on('keydown', controller.onKeyPress);

    };

    taillightUx.directive('tuxNumeric', function () {

        return {
            restrict: 'A',
            link: tuxNumericPostLink,
            controller: tuxNumericController,
            controllerAs: 'ctrl',
            scope: { nonNegative: "@?" }
        }

    });

    taillightUx.directive('tuxPrice', function () {

        return {
            restrict: 'A',
            link: function(scope,elem, attrs) {
                elem.bind('keypress', function(e){
                    var newVal=$(this).val()+(e.charCode!==0?String.fromCharCode(e.charCode):'');
                    if($(this).val().search(/(.*)\.[0-9][0-9]/)===0 && newVal.length>$(this).val().length){
                        e.preventDefault();
                    }
                });
            }
        }

    });

    taillightUx.directive('tuxThousandths', function () {

        return {
            restrict: 'A',
            link: function(scope,elem, attrs) {
                elem.bind('keypress', function(e){
                    var newVal=$(this).val()+(e.charCode!==0?String.fromCharCode(e.charCode):'');
                    if($(this).val().search(/(.*)\.[0-9][0-9][0-9]/)===0 && newVal.length>$(this).val().length){
                        e.preventDefault();
                    }
                });
            }
        }

    });

    taillightUx.directive('tuxPhone', ['$filter', '$browser', function($filter, $browser) {
        return {
            require: 'ngModel',
            link: function($scope, $element, $attrs, ctrl) {
                var listener = function() {
                    var value = $element.val().replace(/[^0-9]/g, '');
                    $element.val($filter('tel')(value));
                };

                ctrl.$parsers.push(function(viewValue) {
                    return viewValue.replace(/[^0-9]/g, '').slice(0, 10);
                });
                ctrl.$render = function() {
                    $element.val($filter('tel')(ctrl.$viewValue, false));
                };
                $element.bind('change', listener);
                $element.bind('keyup', function(event) {
                    var key = event.keyCode;
                    if (key == 91 || (15 < key && key < 19) || (37 <= key && key <= 40)) {
                        return;
                    }
                    $browser.defer(listener);
                });
                $element.bind('paste cut', function() {
                    $browser.defer(listener);
                });
                ctrl.$validators.tuxPhone = function(modelValue, viewValue) {
                    var REG_EXP = /^(\()?(\d{3})(\)\s{0,2})?(\d{3})(-|\s)?(\d{4})$/;
                    if (ctrl.$isEmpty(modelValue) || REG_EXP.test(modelValue)) {
                        return true;
                    }
                    return false;
                };
            }
        };
    }]);
    taillightUx.filter('tel', function() {
        return function(tel) {
            if (!tel) {
                return '';
            }
            var value = tel.toString().trim().replace(/^\+/, '');
            if (value.match(/[^0-9]/)) {
                return tel;
            }
            var  city, number;
            switch (value.length) {
                case 1:
                    city = value;
                    break;
                default:
                    city = value.slice(0, 3);
                    number = value.slice(3);
            }
            if (number) {
                if (number.length > 3) {
                    number = number.slice(0, 3) + '-' + number.slice(3, 7);
                } else {
                    number = number;
                }
                return ("(" + city + ") " + number).trim();
            } else {
                return "(" + city;
            }
        };
    });


    taillightUx.directive('tuxZip', ['$filter', '$browser', function($filter, $browser) {
        return {
            require: 'ngModel',
            link: function($scope, $element, $attrs, ctrl) {
                var listener = function() {
                    var value = $element.val().replace(/[^0-9]/g, '');
                    $element.val($filter('zip')(value));
                };

                ctrl.$parsers.push(function(viewValue) {
                    return viewValue.replace(/[^0-9]/g, '').slice(0, 9);
                });
                ctrl.$render = function() {
                    $element.val($filter('zip')(ctrl.$viewValue, false));
                };
                $element.bind('change', listener);
                $element.bind('keyup', function(event) {
                    var key = event.keyCode;
                    if (key == 91 || (15 < key && key < 19) || (37 <= key && key <= 40)) {
                        return;
                    }
                    $browser.defer(listener);
                });
                $element.bind('paste cut', function() {
                    $browser.defer(listener);
                });
                ctrl.$validators.tuxZip = function(modelValue, viewValue) {
                    var REG_EXP = /^((\d{5})|(\d{9}))$/;
                    if (ctrl.$isEmpty(modelValue) || REG_EXP.test(modelValue)) {
                        return true;

                    }

                    return false;
                };
            }
        };
    }]);
    taillightUx.filter('zip', function() {
        return function(zip) {
            if (!zip) {
                return '';
            }
            var value = zip.toString().trim().replace(/^\+/, '');
            if (value.match(/[^0-9]/)) {
                return zip;
            }
            var  zip, zipExtended;
            switch (value.length) {
                case 1:
                    zip = value;
                    break;
                default:
                    zip = value.slice(0, 5);
                    zipExtended = value.slice(5);
            }
            if (zipExtended) {
                if (zipExtended.length > 4) {
                    zipExtended = zipExtended.slice(0, 4);
                } else {
                    zipExtended = zipExtended;
                }
                return (zip + "-" + zipExtended).trim();
            } else {
                return  zip;
            }
        };
    });

})();